const initSlider = (slider) => {
  const count = 5; // ! actual value: parseInt(slider.dataset.count);
  const items = slider.querySelectorAll('.application--slider');
  const indicators = slider.querySelectorAll('.applications-slider__indicator');
  let runningTimeout;

  items[0].classList.add('active');
  indicators[0].classList.add('active');

  const autoSwitchTimer = 5000;
  let currentIndex = 0;
  let userControlled = false;

  function setActive(increase) {
    $count = parseInt(slider.dataset.count);
    $reset = false;
    if(currentIndex == ($count - 1)){
      let currentIndex = 0;
      $reset = false;
    }
    items[currentIndex].classList.remove('active');
    indicators[currentIndex].classList.remove('active');

    if (increase) {
      currentIndex++;
      if (currentIndex == ($count)) {
        currentIndex = 0;
      }
    } else {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = count - 1;
      }
    }

    items[currentIndex].classList.add('active');
    indicators[currentIndex].classList.add('active');
  }

  function increment() {
    setActive(true);
  }

  function decrement() {
    setActive(false);
  }

  function goToIndex(target) {
    items[currentIndex].classList.remove('active');
    indicators[currentIndex].classList.remove('active');
    currentIndex = target;
    items[currentIndex].classList.add('active');
    userControlled = true;
    clearTimeout(runningTimeout);

    setTimeout(() => {
      userControlled = false;
      loopSlider();
    }, autoSwitchTimer);

    indicators[currentIndex].classList.add('active');
  }

  function loopSlider() {
    runningTimeout = setTimeout(() => {
      if (userControlled) {
        loopSlider();
        return;
      }
      increment();
      loopSlider();
    }, autoSwitchTimer);
  }

  loopSlider();

  indicators.forEach((indicator) => {
    indicator.addEventListener('click', (event) => {
      event.preventDefault();
      goToIndex(parseInt(indicator.dataset.index));
    });
  });

  // const controllers = slider.querySelectorAll('.applications-slider__control');
  // controllers[0].addEventListener('click', () => {
  //   decrement();
  //   userControlled = true;

  //   setTimeout(() => {
  //     userControlled = false;
  //   }, autoSwitchTimer);
  // });
  // controllers[1].addEventListener('click', () => {
  //   increment();
  //   userControlled = true;

  //   setTimeout(() => {
  //     userControlled = false;
  //   }, autoSwitchTimer);
  // });

  let currentX = 0;
  slider.addEventListener('touchstart', (event) => {
    const touches = event.changedTouches[0];
    currentX = touches.clientX;
  });

  slider.addEventListener('touchend', (event) => {
    const touches = event.changedTouches[0];
    console.log('end');
    if (touches.clientX > currentX + 25) {
      decrement();
    } else if (touches.clientX < currentX - 25) {
      increment();
    }
  });
};

const applicationsSliders = document.querySelectorAll('.applications-slider');
applicationsSliders.forEach(initSlider);
